import swal from 'sweetalert2'

const systemMessages = {
  'BinOutOfRange': 'Faixa fora do intervalo',
  'InvalidRowNumber': `Não há dados suficientes`,
  'NoRecords': 'Nenhum registro encontrado',
  'PkReadFail': 'Erro ao ler a chave primária'
}

const messenger = {
  error (args) {
    let options = {
      toast: true,
      position: args.hasOwnProperty('position') ? args.position : 'top-end',
      showConfirmButton: false,
      timer: args.hasOwnProperty('timer') ? args.timer : 3000,
      icon: 'error',
      title: args.hasOwnProperty('title') ? args.title : 'error'
    }
    this.toast(options)
  },
  info (args) {
    let options = {
      toast: true,
      position: args.hasOwnProperty('position') ? args.position : 'top-end',
      showConfirmButton: false,
      timer: args.hasOwnProperty('timer') ? args.timer : 3000,
      icon: 'info',
      title: args.hasOwnProperty('title') ? args.title : 'error'
    }
    this.toast(options)
  },
  save (args) {
    return swal.fire({
      input: args.hasOwnProperty('input') ? args.input : '',
      inputLabel: args.hasOwnProperty('inputLabel') ? args.inputLabel : '',
      inputOptions: args.hasOwnProperty('inputOptions') ? args.inputOptions : {},
      inputPlaceholder: args.hasOwnProperty('inputPlaceholder') ? args.inputPlaceholder : '',
      inputValue: args.hasOwnProperty('inputValue') ? args.inputValue : '',
      inputValidator: args.hasOwnProperty('inputValidator') ? args.inputValidator : undefined,
      title: args.hasOwnProperty('title') ? args.title : '',
      text: args.hasOwnProperty('text') ? args.text : '',
      html: args.hasOwnProperty('html') ? args.html : '',
      icon: args.hasOwnProperty('type') ? args.type : null,
      showCancelButton: false,
      cancelButtonText: args.hasOwnProperty('cancelButtonText') ? args.cancelButtonText : '<i class="fas fa-ban"></i>',
      showCloseButton: false,
      focusConfirm: false,
      showConfirmButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: args.hasOwnProperty('confirmButtonText') ? args.confirmButtonText : '<i class="fas fa-save"></i> Salvar',
      confirmButtonAriaLabel: 'Confirmar',
      cancelButtonAriaLabel: 'Cancelar',
      footer: args.hasOwnProperty('footer') ? args.footer : null,


    })
  },
  input (args) {
    return swal.fire({
      input: args.hasOwnProperty('input') ? args.input : '',
      inputLabel: args.hasOwnProperty('inputLabel') ? args.inputLabel : '',
      inputOptions: args.hasOwnProperty('inputOptions') ? args.inputOptions : {},
      inputPlaceholder: args.hasOwnProperty('inputPlaceholder') ? args.inputPlaceholder : '',
      inputValue: args.hasOwnProperty('inputValue') ? args.inputValue : '',
      inputValidator: args.hasOwnProperty('inputValidator') ? args.inputValidator : undefined,
      title: args.hasOwnProperty('title') ? args.title : '',
      text: args.hasOwnProperty('text') ? args.text : '',
      html: args.hasOwnProperty('html') ? args.html : '',
      icon: args.hasOwnProperty('type') ? args.type : null,
      showCancelButton: args.hasOwnProperty('showCancelButton') ? args.showCancelButton : false,
      cancelButtonText: args.hasOwnProperty('cancelButtonText') ? args.cancelButtonText : '<i class="fas fa-ban"></i>',
      showCloseButton: true,
      focusConfirm: false,
      showConfirmButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: args.hasOwnProperty('confirmButtonText') ? args.confirmButtonText : '<i class="fas fa-save"></i>',
      confirmButtonAriaLabel: 'Confirmar',
      cancelButtonAriaLabel: 'Cancelar',
      footer: args.hasOwnProperty('footer') ? args.footer : null
    })
  },
  messages: systemMessages,
  show (args) {
    return swal.fire({
      title: args.hasOwnProperty('title') ? args.title : '',
      html: args.hasOwnProperty('html') ? args.html : '',
      text: args.hasOwnProperty('text') ? args.text : '',
      icon: args.hasOwnProperty('type') ? args.type : 'info',
      showCancelButton: args.hasOwnProperty('showCancelButton') ? args.showCancelButton : false,
      confirmButtonText: args.hasOwnProperty('confirmButtonText') ? args.confirmButtonText : 'OK',
      cancelButtonText: args.hasOwnProperty('cancelButtonText') ? args.cancelButtonText : 'Cancelar',
      confirmButtonAriaLabel: 'Thumbs up',
      cancelButtonAriaLabel: 'Thumbs down'
    })
  },
  success (args) {
    let options = {
      toast: true,
      target: args.target,
      position: args.hasOwnProperty('position') ? args.position : 'top-end',
      showConfirmButton: false,
      timer: args.hasOwnProperty('timer') ? args.timer : 3000,
      icon: 'success',
      title: args.hasOwnProperty('title') ? args.title : 'success'
    }
    this.toast(options)
  },
  toast (args) {
    const toast = swal.mixin({
      toast: true,
      position: args.hasOwnProperty('position') ? args.position : 'top-end',
      showConfirmButton: false,
      timer: args.hasOwnProperty('timer') ? args.timer : 3000,
      timerProgressBar: true
    })

    toast.fire({
      icon: args.hasOwnProperty('icon') ? args.icon : 'info',
      title: args.hasOwnProperty('title') ? args.title : ''
    })
  },
  warn (args) {
    let options = {
      toast: true,
      position: args.hasOwnProperty('position') ? args.position : 'top-end',
      showConfirmButton: false,
      timer: args.hasOwnProperty('timer') ? args.timer : 3000,
      icon: 'warning',
      title: args.hasOwnProperty('title') ? args.title : 'warning'
    }
    this.toast(options)
  },
  showBufferMsg (data) {
    let message = `${data.message || data.msg || 'Ops...algo deu errado'}<br/>`
    if (data.hasOwnProperty('affected')) {
      message = `${message}Limite: ${data.limit}<br/>Afetados: ${data.affected}`
    }
    this.warn({timer: 5000, position: 'center', title: message})
  }
}

export default messenger
